module.exports = __webpack_public_path__ + "static/media/65720036-EKes2Sgs.7ec6bbd5.JPG";